export default {
  'sysNotice.button.detail': '详情',
  'sysNotice.query.title': '标题',
  'sysNotice.query.title.placeholder': '请输入标题',
  'sysNotice.query.type': '公告类型',
  'sysNotice.query.type.placeholder': '请选择公告类型',
  'sysNotice.query.status': '公告状态',
  'sysNotice.query.status.placeholder': '请选择公告状态',
  'sysNotice.query.status.normal': '正常',
  'sysNotice.query.status.disabled': '禁用',
  'sysNotice.column.title': '标题',
  'sysNotice.column.type': '公告类型',
  'sysNotice.column.description': '公告描述',
  'sysNotice.column.status': '公告状态',
  'sysNotice.column.status.normal': '正常',
  'sysNotice.column.status.disabled': '禁用',
  'sysNotice.column.createTime': '创建时间',
  'sysNotice.column.updateTime': '修改时间',
  // edit
  'sysNotice.edit.title': '修改通知公告',
  'sysNotice.edit.success': '修改成功',
  'sysNotice.add.title': '新增通知公告',
  'sysNotice.add.success': '新增成功',
  'sysNotice.edit.form.title': '标题',
  'sysNotice.edit.form.title.placeholder': '请输入标题',
  'sysNotice.edit.form.title.required': '请输入标题',
  'sysNotice.edit.form.description': '公告描述',
  'sysNotice.edit.form.description.placeholder': '请输入公告描述',
  'sysNotice.edit.form.description.required': '请输入公告描述',
  'sysNotice.edit.form.type': '公告类型',
  'sysNotice.edit.form.type.placeholder': '请选择公告类型',
  'sysNotice.edit.form.type.required': '请选择公告类型',
  'sysNotice.edit.form.status': '公告状态',
  'sysNotice.edit.form.status.placeholder': '请选择公告状态',
  'sysNotice.edit.form.status.required': '请选择公告状态',
  'sysNotice.edit.form.status.normal': '正常',
  'sysNotice.edit.form.status.disabled': '禁用',
  'sysNotice.edit.form.content': '公告内容',
  'sysNotice.edit.form.content.placeholder': '请输入公告内容',
  'sysNotice.edit.form.content.required': '请输入公告内容',
  // view dialog
  'sysNotice.viewDialog.title': '通知公告',
  'sysNotice.viewDialog.publisher': '发布人',
  'sysNotice.viewDialog.createTime': '发布时间',
  'sysNotice.viewDialog.noPublisher': '未知',
}
